<template>
  <v-app>
    <Header/>
    <Sidebar/>
    <v-content>
      <v-container fluid py-2 px-3 style="padding-bottom: 0 !important;">
        <v-layout wrap>
          <v-flex text-xs-left xs12 md4 px-3>
            <v-select :items="filterCustomers" v-model="filterCustomer" item-text="name" prepend-icon="a-store" return-object @change="loadSalesSummaries" class="customerFilter"/>
          </v-flex>
          <v-flex text-xs-left xs12 md8>
            <v-autocomplete :items="filterCategories" v-model="filterCategoryList" item-text="displayLabel" prepend-icon="a-trees" return-object multiple @change="loadSalesSummaries" class="categoryFilter">
              <template slot="selection" slot-scope="data">
                <div style="padding-right: 30px;">
                  <div v-if="data.item.color && !(data.item.color.secondColor && data.item.color.secondColor !== '')" :style="'display: inline-block; margin: 5px 10px 1px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background-color: #' + data.item.color.color + ';'"></div>
                  <div v-if="data.item.color && data.item.color.secondColor && data.item.color.secondColor !== ''" :style="'display: inline-block; margin: 5px 10px 1px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background: repeating-linear-gradient(-45deg, #' + data.item.color.color + ', #' + data.item.color.color + ' 3px, #' + data.item.color.secondColor + ' 3px, #' + data.item.color.secondColor + ' 6px);'"></div>
                  <div style="display: inline-block; vertical-align: top; padding-top: 5px;">{{ data.item.displayLabel }}</div>
                </div>
              </template>
              <template slot="item" slot-scope="data">
                <div style="width: 30px; padding-right: 10px !important;">
                  <v-checkbox :input-value="itemSelected(filterCategoryList, data.item)" color="primary" style="width: 30px;"/>
                </div>
                <div v-if="data.item.color && !(data.item.color.secondColor && data.item.color.secondColor !== '')" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background-color: #' + data.item.color.color + ';'"></div>
                <div v-if="data.item.color && data.item.color.secondColor && data.item.color.secondColor !== ''" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background: repeating-linear-gradient(-45deg, #' + data.item.color.color + ', #' + data.item.color.color + ' 3px, #' + data.item.color.secondColor + ' 3px, #' + data.item.color.secondColor + ' 6px);'"></div>
                {{ data.item.displayLabel }}
              </template>
            </v-autocomplete>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container fluid py-3 px-3 v-if="showSales">
        <v-layout style="max-height: calc(100vh - 170px);">
          <v-flex style="border: 1px solid #DDDDDD; border-radius: 3px; overflow-y: auto;">
            <v-data-table :headers="headers" :items="salesSummaries" hide-actions no-data-text="No sales data found" class="salesTable" :key="updateCounter">
              <template v-slot:items="props">
                <tr :class="rowClass(props.item)" v-if="showItem(props.item)">
                  <td class="text-xs-left" style="width: 15px; padding-left: 5px !important; padding-right: 0 !important; padding-top: 2px !important; padding-bottom: 0 !important;'">
                    <v-icon style="font-size: 20px;" v-if="showExpandIcon(props.item)" @click="categoryClicked(props.item)">chevron_right</v-icon>
                    <v-icon style="font-size: 20px;" v-if="showCollapseIcon(props.item)" @click="categoryClicked(props.item)">expand_more</v-icon>
                  </td>
                  <td class="text-xs-left" @click="categoryClicked(props.item)" style="width: 20px; padding-left: 4px !important; padding-right: 0 !important; cursor: pointer;">
                    <div v-if="showCategory(props.item)" style="padding-top: 1px;">
                      <div v-if="props.item.category.color && !(props.item.category.color.secondColor && props.item.category.color.secondColor !== '')" :style="'margin: 3px 5px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background-color: #' + props.item.category.color.color + ';'"></div>
                      <div v-if="props.item.category.color && props.item.category.color.secondColor && props.item.category.color.secondColor !== ''" :style="'margin: 3px 5px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background: repeating-linear-gradient(-45deg, #' + props.item.category.color.color + ', #' + props.item.category.color.color + ' 3px, #' + props.item.category.color.secondColor + ' 3px, #' + props.item.category.color.secondColor + ' 6px);'"></div>
                    </div>
                  </td>
                  <td class="text-xs-left category">
                    <div v-if="showCategory(props.item)" @click="categoryClicked(props.item)" style="padding-top: 2px; cursor: pointer;">
                      {{ props.item.category.displayLabel }}
                    </div>
                    <div v-if="showCustomer(props.item)" class="customer">
                      {{ props.item.customer.name }}
                    </div>
                    <div v-if="showSubTotal(props.item)" class="subTotal">
                      Subtotal
                    </div>
                    <div v-if="showTotal(props.item)" class="total">
                      Total
                    </div>
                  </td>
                  <td class="text-xs-right amount" style="width: 100px;">{{ props.item.orderedAmount.toLocaleString() }}</td>
                  <td class="text-xs-right amount" style="width: 100px;">{{ showLabelled(props.item) ? props.item.labelledAmount.toLocaleString() : '' }}</td>
                  <td class="text-xs-right amount" style="width: 100px;">{{ showAvailable(props.item) ? props.item.availableAmount.toLocaleString() : '' }}</td>
                  <td class="text-xs-right amount" style="width: 140px;">
                    <div v-if="showPlanned(props.item)" style="display: inline;">
                      {{ props.item.plannedAmount.toLocaleString() }}
                    </div>
                    <div v-if="showPlanned(props.item) && props.item.orderedAmount > 0" style="display: inline;">
                    / {{ Number(Number(100 * props.item.plannedAmount / props.item.orderedAmount).toFixed(0)).toLocaleString() + '%' }}
                    </div>
                  </td>
                  <td class="text-xs-right amount" style="width: 140px;">
                    <div v-if="showDelivered(props.item)" style="display: inline;">
                      {{ props.item.deliveredAmount.toLocaleString() }}
                    </div>
                    <div v-if="showDelivered(props.item) && props.item.orderedAmount > 0" style="display: inline;">
                      / {{ Number(Number(100 * props.item.deliveredAmount / props.item.orderedAmount).toFixed(0)).toLocaleString() + '%' }}
                    </div>
                  </td>
                  <td class="text-xs-right amount" style="width: 100px; padding-right: 25px !important;">
                    <div style="display: inline;">
                      {{ Number(props.item.deliveredStatusAmount).toLocaleString() }}
                    </div>
                  </td>
                  <td class="comment">
                    <div v-if="showComment(props.item)">{{ props.item.comment }}</div>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
    <Footer/>
  </v-app>
</template>

<script>
import Header from '../components/Header'
import Sidebar from '../components/Sidebar'
import Footer from '../components/Footer'
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  name: 'Sales',
  components: { Header, Sidebar, Footer },
  data () {
    return {
      salesOverview: false,
      salesSummaries: [],
      filterCustomers: [],
      filterCustomer: { id: 0 },
      filterCategories: [],
      filterCategoryList: [],
      expandedCategories: new Map(),
      updateCounter: 0
    }
  },
  created: function () {
    this.$store.dispatch('page/setSidebarItem', { key: 'sales' })
    this.loadSalesSummaries()
    this.loadFilterCustomers()
    this.loadFilterCategories()
  },
  computed: {
    headers: function () {
      let headers = []
      headers.push({ text: '', sortable: false })
      headers.push({ text: '', sortable: false })
      headers.push({ text: 'Category', value: 'category.label', sortable: false })
      headers.push({ text: 'Ordered', value: 'orderedAmount', align: 'right', sortable: false })
      headers.push({ text: 'Labelled', value: 'labelledAmount', align: 'right', sortable: false })
      headers.push({ text: 'Status', value: 'availableAmount', align: 'right', sortable: false })
      headers.push({ text: 'Planned', value: 'plannedAmount', align: 'right', sortable: false })
      headers.push({ text: 'Delivered', value: 'deliveredAmount', align: 'right', sortable: false })
      headers.push({ text: 'Delivered status', value: 'deliveredStatusAmount', align: 'right', sortable: false })
      headers.push({ text: 'Comments', value: 'comments', align: 'left', sortable: false })
      return headers
    },
    hasArchivedProduction: function () {
      return this.$store.getters['session/hasArchivedProduction']
    },
    showSales: function () {
      return this.salesOverview
    },
    customerSpecific: function () {
      return this.filterCustomer.id > 0
    },
    ...mapGetters({
      sessionSalesOrganizations: 'session/getSalesOrganizations'
    })
  },
  methods: {
    async loadSalesSummaries () {
      this.salesOverview = false
      this.salesSummaries = []
      let categoryIds = []
      for (let cat of this.filterCategoryList) {
        categoryIds.push(cat.id)
      }
      let params = ''
      if (this.filterCustomer && this.filterCustomer.id > 0) {
        params += (params !== '' ? '&' : '?')
        params += 'customer=' + this.filterCustomer.id
      }
      if (categoryIds.length > 0) {
        params += (params !== '' ? '&' : '?')
        params += 'categories=' + categoryIds.join(',')
      }
      await axios.get('/backend/rest/sales/summary' + params)
        .then(response => {
          this.salesSummaries = response.data
          this.salesOverview = true
          if (this.salesSummaries) {
            let estimatedTotal = 0
            let adjustedEstimateTotal = 0
            let estimatedStatusTotal = 0
            let forecastTotal = 0
            let forecastStatusTotal = 0
            let labelledTotal = 0
            let orderedTotal = 0
            let availableTotal = 0
            let plannedTotal = 0
            let deliveredTotal = 0
            let deviationTotal = 0
            let deliveredStatusTotal = 0
            for (let summary of this.salesSummaries) {
              if (summary.category) {
                this.expandedCategories.set(summary.category.id, false)
              }
              if (!summary.subTotal && ((this.filterCustomer && this.filterCustomer.id > 0) || !summary.customer)) {
                estimatedTotal += summary.estimatedAmount
                adjustedEstimateTotal += summary.adjustedEstimateAmount
                estimatedStatusTotal += summary.estimatedStatusAmount
                forecastTotal += summary.forecastAmount
                forecastStatusTotal += summary.forecastStatusAmount
                labelledTotal += summary.labelledAmount
                availableTotal += summary.availableAmount
                orderedTotal += summary.orderedAmount
                plannedTotal += summary.plannedAmount
                deliveredTotal += summary.deliveredAmount
                deviationTotal += summary.deviationAmount
                deliveredStatusTotal += summary.deliveredStatusAmount
              }
            }
            this.salesSummaries.push({
              subTotal: false,
              type: 'total',
              estimatedAmount: estimatedTotal,
              adjustedEstimateAmount: adjustedEstimateTotal,
              estimatedStatusAmount: estimatedStatusTotal,
              forecastAmount: forecastTotal,
              forecastStatusAmount: forecastStatusTotal,
              labelledAmount: labelledTotal,
              orderedAmount: orderedTotal,
              availableAmount: availableTotal,
              plannedAmount: plannedTotal,
              deliveredAmount: deliveredTotal,
              deviationAmount: deviationTotal,
              deliveredStatusAmount: deliveredStatusTotal
            })
          }
        })
    },
    loadFilterCustomers () {
      axios.get('/backend/rest/customer')
        .then(response => {
          let filterCustomers = response.data
          filterCustomers.sort(function (f1, f2) {
            return f1.name.localeCompare(f2.name)
          })
          filterCustomers.splice(0, 0, {
            id: 0,
            name: ''
          })
          this.filterCustomers = filterCustomers
        })
    },
    loadFilterCategories () {
      axios.get('/backend/rest/category')
        .then(response => {
          this.filterCategories = response.data
        })
    },
    showCategory (summary) {
      return (this.customerSpecific || !summary.customer) && summary.category
    },
    showCustomer (summary) {
      return !this.customerSpecific && summary.customer && summary.category
    },
    showSubTotal (summary) {
      return summary.subTotal
    },
    showTotal (summary) {
      return summary.type === 'total'
    },
    showForecast (summary) {
      return (this.customerSpecific || !summary.customer) && summary.forecastAmount >= 0
    },
    showAdjustedEstimate (summary) {
      return this.customerSpecific || !summary.customer
    },
    showForecastStatus (summary) {
      return this.customerSpecific || !summary.customer
    },
    showLabelled (summary) {
      return this.customerSpecific || !summary.customer
    },
    showAvailable (summary) {
      return this.customerSpecific || !summary.customer
    },
    showPlanned (summary) {
      return !summary.order
    },
    showDelivered (summary) {
      return !summary.order
    },
    showComment (summary) {
      return this.customerSpecific || summary.customer
    },
    showItem (summary) {
      return !summary.customer || this.customerSpecific || this.expandedCategories.get(summary.category.id) || summary.type === 'total'
    },
    showExpandIcon (summary) {
      return !this.customerSpecific && this.showCategory(summary) && !this.expandedCategories.get(summary.category.id) && !(summary.type === 'total') && summary.orderedAmount && summary.orderedAmount > 0
    },
    showCollapseIcon (summary) {
      return !this.customerSpecific && this.showCategory(summary) && this.expandedCategories.get(summary.category.id) && !(summary.type === 'total') && summary.orderedAmount && summary.orderedAmount > 0
    },
    categoryClicked (summary) {
      let expanded = this.expandedCategories.get(summary.category.id)
      expanded = !expanded
      this.expandedCategories.set(summary.category.id, expanded)
      this.updateCounter++
    },
    rowClass (summary) {
      return this.showCategory(summary) || this.showCustomer(summary) ? 'field' : this.showSubTotal(summary) ? 'subTotal' : 'total'
    },
    itemSelected (items, item) {
      if (item && items && items instanceof Array) {
        for (let i of items) {
          if (i instanceof Object) {
            if (i.id === item.id) {
              return true
            }
          } else if (i === item.id) {
            return true
          }
        }
      }
      return false
    }
  },
  watch: {
    sessionSalesOrganizations () {
      this.filterCustomer = { id: 0 }
      this.loadSalesSummaries()
      this.loadFilterCustomers()
    }
  }
}
</script>
<style scoped>
  html {
    overflow-y: auto;
  }
  tr.total td.amount,
  tr.field td.amount {
    padding-right: 18px !important;
    padding-top: 2px !important;
  }
  tr td.comment:not(:first-child) {
    padding-top: 2px !important;
    white-space: pre;
  }
  tr td.category:not(:first-child) {
    width: 200px;
    padding-right: 25px !important;
  }
  tr td.amount:not(:first-child) {
    padding: 2px 10px !important;
  }
  tr td.category,
  tr td.amount {
    white-space: nowrap;
  }
  tr.field td div.customer,
  tr.field td div.order,
  tr.field td.field,
  tr.field td.amount {
  }
  tr.field td div.customer {
    padding-left: 10px;
  }
  tr.field td div.order {
    padding-left: 20px;
  }
  tr.total td.total,
  tr.total td.amount {
    padding-top: 2px !important;
  }
  tr.subTotal td,
  tr.total td {
    font-weight: bold;
    color: rgba(0, 0, 0, 0.54);
  }
  tr.subTotal td.category,
  tr.subTotal td.amount {
    padding-bottom: 10px !important;
  }
  tr.total td.category,
  tr.total td.amount {
    padding-top: 10px !important;
  }
  tr.subTotal td div.subTotal {
    padding-top: 2px !important;
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Sales.vue